


const Privacy=()=>{
     
    return(
        <div className="container p-5">
<div>
 <h2><b>WHO WE ARE</b></h2>
</div>
<p>GAYATHRI COFFEE Pvt. Ltd. administers the http://7kj.69c.myftpupload.com website, which provides the SERVICEs of selling prints & products.
If any website visitors want to utilise our Service, they should be aware of our rules regarding the collection, use, and sharing of their Personal Information.
</p>
<p>You consent to the collection and use of your information in line with this policy if you choose to use our Service. The Personal Information we gather is used to deliver and enhance the Service. We won’t use or disclose your information in any other way than what is stated in this privacy statement.
</p>
<p>The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which are accessible unless otherwise defined in this Privacy Policy.</p>
<div>
<h2><b>INFORMATION ACCESSED WHEN VISITING OUR WEBSITE</b></h2>
</div>

<p>We automatically gather certain information about your device when you access the Site, including information about your web browser, IP address, time zone, and some of the cookies that have been set up on it. Along with this, we also keep track of the specific web pages or items you view while using the site, the websites or search keywords that led you there, and your interactions with the site. We term this automatically gathered data “Device Information.”</p>
<div>
<h2><b>SECURITY</b></h2>
</div>
<p>
We are dedicated to protecting the privacy and security of your information. We have appropriate physical, technical, and administrative safeguards in place to prevent unauthorised access to or disclosure of the information we collect online.
</p>
<div><h2><b>MODIFICATION TO PRIVACY POLICY</b></h2></div>
<p>Periodically, we might update our privacy policy. As a result, we encourage you to periodically check this page for modifications of that nature. By publishing the updated Privacy Policy on this website, we will let you know about any changes. When these modifications are uploaded to this website, they take effect right away.</p>
<div><h2><b>Contact Us</b></h2></div>
<p>If there are any questions regarding this privacy policy you may contact us using the information below: reachus@gayathricoffee.com</p>

</div>
    )
}
export default Privacy;